import { isBuilt, type ModuleManifest, type RegistryEntry } from './manifest';

/** Is `pathname` the base itself or something under it? Segment-aware. */
export function underPath(base: string, pathname: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

/**
 * Which module owns this URL, by longest prefix match.
 *
 * The location is the only input: a deep link, a refresh, a pasted URL and the
 * back button all restore the same sidebar, and navigating writes no state.
 * The shell's own pages (`/modules`, `/dashboard`, `/profile`, `/settings`,
 * `/notifications`, `/forbidden`) match nothing and render no sidebar.
 */
export function activeModule(entries: RegistryEntry[], pathname: string): ModuleManifest | null {
  const built = entries.filter(isBuilt);
  let best: ModuleManifest | null = null;
  for (const module of built) {
    if (underPath(module.prefix, pathname) && (!best || module.prefix.length > best.prefix.length)) {
      best = module;
    }
  }
  return best;
}
